function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Group } from '../../../../containers';
import { Icon } from '../../../../foundations/Icon';
import { useMultiStyleConfig } from '../../../../utils/use-style-config';
import { Avatar, Badge, BrandSymbol, Text, Typography } from '../../../dataDisplay';
import { Box } from '../../Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var OptionContent = _ref => {
  var _avatarProps$name;

  var {
    avatarProps,
    leftIcon,
    rightIcon,
    badgeProps,
    description,
    label,
    isSelected
  } = _ref;
  var styles = useMultiStyleConfig('BaseSelect', {});
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [leftIcon && /*#__PURE__*/_jsx(BrandSymbol, {
      type: leftIcon,
      size: "small"
    }), avatarProps && /*#__PURE__*/_jsx(Avatar, _objectSpread(_objectSpread({}, avatarProps), {}, {
      name: (_avatarProps$name = avatarProps.name) !== null && _avatarProps$name !== void 0 ? _avatarProps$name : label,
      size: "small",
      isSelected: isSelected
    })), /*#__PURE__*/_jsxs(Group, {
      variant: "vertical",
      spacing: "xxs",
      children: [/*#__PURE__*/_jsxs(Group, {
        spacing: "xxs",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Text, {
          textStyle: "inline",
          color: "inherit",
          shouldSupportEllipsis: true,
          children: label
        }), rightIcon && /*#__PURE__*/_jsx(Icon, {
          type: rightIcon,
          size: "small"
        }), badgeProps && /*#__PURE__*/_jsx(Badge, _objectSpread({
          type: "secondary"
        }, badgeProps))]
      }), description && /*#__PURE__*/_jsx(Typography.Description, {
        label: description
      })]
    }), isSelected && /*#__PURE__*/_jsx(Box, {
      __css: styles['checkedIcon'],
      children: /*#__PURE__*/_jsx(Icon, {
        type: "checked",
        color: "brand",
        size: "small"
      })
    })]
  });
};
OptionContent.displayName = 'BaseSelect.OptionContent';
//# sourceMappingURL=OptionContent.js.map